import React from "react";

import styles from "./EmptyList.module.css";

type EmptyListPlaceholderProps = EmptyListProps & {
  data: any[];
  children: React.ReactNode;
};
export function EmptyListPlaceholder({
  data,
  children,
  ...props
}: EmptyListPlaceholderProps) {
  if (data.length === 0) {
    return <EmptyList {...props} />;
  }
  return <>{children}</>;
}

interface EmptyListProps {
  image?: string;
  imageAltText?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
}
function EmptyList({
  image,
  imageAltText,
  title,
  description,
}: EmptyListProps) {
  return (
    <div className={styles.root}>
      {image && <img className={styles.image} src={image} alt={imageAltText} />}
      <p className={styles.text}>{title}</p>
      {description && <p className={styles.text}>{description}</p>}
    </div>
  );
}
